module.exports = __webpack_public_path__ + "img/software-recharge.b213c203.png";